import { withDependencies } from '@wix/thunderbolt-ioc'
import { PlatformEnvDataProvider } from '@wix/thunderbolt-symbols'
import type { ISessionManager } from './types'
import { SessionManagerSymbol } from './symbols'

export const sessionEnvDataProvider = withDependencies(
	[SessionManagerSymbol],
	(sessionManager: ISessionManager): PlatformEnvDataProvider => {
		return {
			get platformEnvData() {
				return {
					session: {
						visitorId: sessionManager.getVisitorId(),
						siteMemberId: sessionManager.getSiteMemberId(),
						applicationsInstances: sessionManager.getAllInstances(),
					},
				}
			},
		}
	}
)
